import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=79ba0480&scoped=true&"
import script from "./staff.vue?vue&type=script&lang=js&"
export * from "./staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba0480",
  null
  
)

export default component.exports